var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4957 7.64465L6.78194 2.9309L2.0682 7.64465C1.5944 8.11845 0.829019 8.11845 0.355215 7.64465C-0.118589 7.17084 -0.118589 6.40547 0.355215 5.93166L5.93153 0.355353C6.40533 -0.118451 7.1707 -0.118451 7.64451 0.355353L13.2208 5.93166C13.6946 6.40547 13.6946 7.17084 13.2208 7.64465C12.747 8.1063 11.9695 8.11845 11.4957 7.64465Z",
    fill: "#C924A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.d2c62643f6ea22392ada2f45428ff2a7.svg";
export { ForwardRef as ReactComponent };